import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://libbenagents.com';

export default function HreflangMeta() {
  const { pathname } = useLocation();

  const ptBrUrl = `${BASE_URL}${pathname}`;
  const enUrl = `${BASE_URL}${pathname}?lng=en`;
  const xDefaultUrl = `${BASE_URL}${pathname}`;

  return (
    <Helmet>
      <link rel="alternate" hreflang="pt-BR" href={ptBrUrl} />
      <link rel="alternate" hreflang="en" href={enUrl} />
      <link rel="alternate" hreflang="x-default" href={xDefaultUrl} />
    </Helmet>
  );
}
